import React from "react";
import { CAR_FEATURE_GROUPS, partitionFeatures } from "@/lib/carFeatures";
import { Check } from "lucide-react";

export function CarFeaturePicker({ selected = [], onToggle, testidPrefix = "listing-feature" }) {
  const set = new Set(selected);
  const { custom: customSelected } = partitionFeatures(selected);

  return (
    <div data-testid={`${testidPrefix}-section`} className="space-y-6">
      {CAR_FEATURE_GROUPS.map((group) => (
        <div key={group.id}>
          <h4 className="text-xs tracking-[0.15em] uppercase text-electric mb-3">{group.label}</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {group.items.map((item) => {
              const active = set.has(item.key);
              return (
                <button
                  key={item.key}
                  type="button"
                  data-testid={`${testidPrefix}-${item.key}`}
                  onClick={() => onToggle?.(item.key)}
                  className={`flex items-start gap-2.5 text-left rounded-xl px-3 py-2.5 border text-sm transition-colors ${
                    active
                      ? "border-electric/50 bg-electric/10 text-white"
                      : "border-white/10 bg-white/[0.02] text-slate-300 hover:border-white/20"
                  }`}
                >
                  <span
                    className={`mt-0.5 w-4 h-4 rounded border flex items-center justify-center shrink-0 ${
                      active ? "bg-electric border-electric text-white" : "border-white/25"
                    }`}
                  >
                    {active && <Check className="w-3 h-3" strokeWidth={3} />}
                  </span>
                  <span className="leading-snug">{item.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
      {customSelected.length > 0 && (
        <div>
          <h4 className="text-xs tracking-[0.15em] uppercase text-electric mb-3">
            További felszereltség (import / egyedi)
          </h4>
          <p className="text-xs text-slate-500 mb-2">
            Ezek a forrás hirdetésből jöttek; kattintással eltávolíthatod, ha nem illik az autóhoz.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {customSelected.map((label) => {
              const active = set.has(label);
              return (
                <button
                  key={label}
                  type="button"
                  data-testid={`${testidPrefix}-custom-${label.slice(0, 24)}`}
                  onClick={() => onToggle?.(label)}
                  className={`flex items-start gap-2.5 text-left rounded-xl px-3 py-2.5 border text-sm transition-colors ${
                    active
                      ? "border-emerald-500/40 bg-emerald-500/10 text-white"
                      : "border-white/10 bg-white/[0.02] text-slate-300 hover:border-white/20"
                  }`}
                >
                  <span
                    className={`mt-0.5 w-4 h-4 rounded border flex items-center justify-center shrink-0 ${
                      active ? "bg-emerald-500 border-emerald-500 text-white" : "border-white/25"
                    }`}
                  >
                    {active && <Check className="w-3 h-3" strokeWidth={3} />}
                  </span>
                  <span className="leading-snug">{label}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
